import React from 'react'
import { FIELD_TYPES } from '../../../../../libs/formdatavalidator/constants';
import FormInput from '../../../../components/forminput/FormInput';
import { addNotifications } from '../../../toaster/ToasterPortalSlice';
import { TOASTER_VARIANT } from '../../../../components/toast/constants';
import styles from './RenderBoiFields.styles';
import Label from '../../../../components/label/Label';
import FormEventHandlers from '../../../../../libs/utility/formeventhandlers/FormEventHandlers';
import { useDispatch } from 'react-redux';
import './../directcss/common.scss';
import General from '../../../../../libs/utility/General';
import Forms from '../../../../../libs/utility/formsutility/Forms';
import { HIDE_LABELS_FOR_FIELD_TYPES, IGNORE_FIELDS } from '../../constants';
import { onDependentFieldChangeGetValues } from '../FileBoiSaga';

export default function RenderBoiFields({stepFields, currentStep, updateFormFieldsCb = () => {}, onDependentFieldChangeGetValuesCb = () => {}, formsPreLoadedData = {}, onDependentFields = {}, disabled = false, setShowHelpPopupCb = () => {}, setHelpTextObjCb = () => {} } ){
    
    const dispatch = useDispatch();
    const toCreateFormData = {
        selectedForm: {
            FormId: currentStep,
        },
        selectedYear: "",
    }

    return <>
        <div style={styles.stepFieldsContainer}>
            {
                stepFields.map((field, idx) => (
                    (!IGNORE_FIELDS.includes(field.Name) && field?.isVisible !== false) ? <div key={field?.Name} style={styles.inputFieldWLabelContainer}>
                        {(field.Type !== FIELD_TYPES.BOOLEAN) && (
                            <span style={{...styles.boxInputFieldLabel, ...(FIELD_TYPES.LABEL ? {width: "100%"} : {})}} className={`${field?.CssClass ?? ""}`} >
                                {!HIDE_LABELS_FOR_FIELD_TYPES.includes(field.Type) && <span dangerouslySetInnerHTML={{ __html: General.sanitizeContent(Forms.replaceKeysInIRSLabelsWVariables(field.Label, {})) }} />}
                                {field?.Validations?.Required?.Value ? <span style={styles.requiredStarLabel}>
                                    <span title={`${field.Name} is Required`}>*</span>
                                </span> : null}
                            </span>
                        )}
                        {
                            (field.Type !== FIELD_TYPES.LABEL) && <div style={styles.inputFieldDiv}>
                                <FormInput
                                    name={field.Name}
                                    type={field.Type}
                                    placeHolder={field.PlaceholderText}
                                    onChangeCb={(e) => FormEventHandlers.inputValueChange(e, field, stepFields, (updatedFieldsList) => updateFormFieldsCb(updatedFieldsList), toCreateFormData, onDependentFields,  (onDependentFieldChangeData) => onDependentFieldChangeGetValuesCb(onDependentFieldChangeData), false)}
                                    fieldObj={field}
                                    fieldsArr={stepFields}
                                    prefixProps={(field.Type === FIELD_TYPES.CURRENCY) ? { text: "$" } : {}}
                                    onBlurCb={(e, inputValidationResult) => FormEventHandlers.handleOnBlur(e, field, stepFields, inputValidationResult, toCreateFormData, onDependentFields, (updatedFieldsList) => updateFormFieldsCb(updatedFieldsList), (onDependentFieldChangeData) => onDependentFieldChangeGetValuesCb(onDependentFieldChangeData))}
                                    hideBorder={(field.Type === FIELD_TYPES.BOOLEAN) ? true : false}
                                    options={(formsPreLoadedData[field?.FrontEndSource] && Array.isArray(formsPreLoadedData[field.FrontEndSource]) ? formsPreLoadedData[field.FrontEndSource] : [])}
                                    dropdownValue={
                                        (field?.inputValue && field.inputValue != "")
                                            ? 
                                                (formsPreLoadedData[field?.FrontEndSource] && Array.isArray(formsPreLoadedData[field.FrontEndSource]) ? formsPreLoadedData[field.FrontEndSource] : []).find(item => item.value == field.inputValue) 
                                            : 
                                                {label: "select", value: ""}
                                    }
                                    dropdownOnSelectCb={(name, selectedOption) => FormEventHandlers.handleDropDownValueChange(name, selectedOption, stepFields, toCreateFormData, onDependentFields, (updatedFieldsList) => updateFormFieldsCb(updatedFieldsList), (onDependentFieldChangeData) => onDependentFieldChangeGetValuesCb(onDependentFieldChangeData), () => {}, true, (heading, message, variant) => handleDispatchNotification(heading, message, variant), false)}
                                    customStyles={(field.Type === FIELD_TYPES.BOOLEAN) ? styles.boxInputFieldLabel : ""}
                                    formsPreLoadedData={formsPreLoadedData}
                                    disabled={(disabled || field?.isReadonly) ? true : false} 
                                    dispatchNotificationCb={(heading, message, variant) => addNotifications({
                                        heading: heading,
                                        message: message,
                                        variant: TOASTER_VARIANT[variant]
                                    })}
                                    tabIndex="0"
                                    helpIconProps={{
                                        onClickCb: (helpText) => {
                                            setShowHelpPopupCb(true);
                                            setHelpTextObjCb(helpText)
                                        }
                                    }} 
                                />
                            </div>
                        }
                        
                    </div>
                    : null
                ))
            }
        </div>
    </>
}